import cs from 'classnames';
import { usePlayerContext, VODProviderType } from 'hamrah-player';
import dynamic from 'next/dynamic';
import type { FC } from 'react';
import { useEffect, useMemo, useState } from 'react';
import { Box, Button, Container } from '@/DesignSystem/Component';
import { useDeviceType } from '@/Module/Core/Hook';
import { DeviceType } from '@/Module/Core/Model/Enum';
import type { ISubscriptionPageVideo } from '@/Module/Subscription/Model/DataModel';
interface IPropsPlayerController {
  playHandler: () => void;
}
const Player = dynamic(() => import('hamrah-player').then(value => value.Player), {
  ssr: false
});
const PlayerCoverController: FC<IPropsPlayerController> = ({
  playHandler
}) => {
  const {
    playerRef,
    initialed
  } = usePlayerContext();
  useEffect(() => {
    if (!playerRef.current || !initialed) return () => {};
    playerRef.current.on('play', playHandler);
    playerRef.current.on('pause', playHandler);
    return () => {
      playerRef.current.off('play', playHandler);
      playerRef.current.off('pause', playHandler);
    };
  }, [playerRef.current, initialed]);
  return null;
};
const SubscriptionPageVideo: FC<ISubscriptionPageVideo> = ({
  url,
  titleTwo,
  titleOne,
  urlMobile
}) => {
  const [isPlaying, setPlaying] = useState(false);
  const deviceType = useDeviceType();
  const playHandler = () => {
    setPlaying(prevState => !prevState);
  };
  const {
    mainUrl
  } = useMemo(() => {
    return {
      mainUrl: (deviceType === DeviceType.MOBILE ? urlMobile : url) ?? url
    };
  }, [deviceType, url, urlMobile]);
  return <div data-sentry-component="SubscriptionPageVideo" data-sentry-source-file="SubscriptionPageVideo.tsx">
      {deviceType === DeviceType.MOBILE ? <div className="relative   md:px-8  ">
          <div className={cs('relative top-0 mx-auto   ')}>
            <div className="mx-auto mb-8 aspect-video sm:mb-0">
              <Player playUrl={mainUrl} vodCustomUrl={{
            [VODProviderType.ABR_HAMRAHI]: '/vod/abrehamrahi/{token}'
          }} vodType={VODProviderType.ABR_HAMRAHI}>
                <PlayerCoverController playHandler={playHandler} />
              </Player>
            </div>
            {!isPlaying && <div className=" absolute bottom-0 z-[10] flex h-full w-full flex-col justify-end bg-[rgba(0,0,0,0.4)] px-2  pb-6 sm:bottom-7 sm:px-8">
                <div className="line-clamp-1 text-center text-xl text-orangeOne md:leading-[35px]"> {titleOne}</div>
                <div className="line-clamp-2 text-center font-bold text-orangeOne sm:line-clamp-2 sm:text-2xl md:text-3xl md:leading-[35px]">
                  {titleTwo}
                </div>
                <div className="my-2 flex w-full sm:mt-8">
                  <Button href="#subscription" as="a" variant="shadow" color="orange" radius="circle" className="order-1 mx-auto w-full   max-w-[290px] cursor-pointer items-center opacity-70 sm:hidden md:!w-full">
                    خرید اشتراک
                  </Button>
                </div>
              </div>}
          </div>
        </div> : <div className="relative   md:px-8  ">
          <Container className="relative  sm:py-14 lg:max-w-[1100px] ">
            <Button radius="circle" color="orange" variant="shadow" className="transform-[-50%] !absolute left-0 top-[50%] !hidden !h-[65px] !w-[65px] animate-leftToRight justify-center !p-0 hover:!bg-orangeFour lg:!flex" />
            <Button radius="circle" color="orange" variant="shadow" className="transform-[-50%] !absolute right-0 top-[50%] !hidden !h-[65px] !w-[65px] animate-rightToLeft justify-center !p-0 hover:!bg-orangeFour lg:!flex" />
            <Box className={cs('relative top-0 mx-auto   before:absolute before:z-10 before:h-full before:bg-orangeSix before:opacity-[0.52] before:transition-all before:duration-200 before:content-[""] hover:before:h-0  hover:before:opacity-0  lg:max-w-[780px]', !isPlaying ? 'before:sm:w-full' : '')} color="orangeMiddle">
              <div className="mx-auto aspect-video">
                <Player playUrl={mainUrl} vodType={VODProviderType.ABR_HAMRAHI} vodCustomUrl={{
              [VODProviderType.ABR_HAMRAHI]: '/vod/abrehamrahi/{token}'
            }}>
                  <PlayerCoverController playHandler={playHandler} />
                </Player>
              </div>
              {!isPlaying && <div className="pointer-events-none absolute bottom-2 z-20  flex w-full flex-col justify-center px-2 sm:bottom-7 sm:px-8">
                  <div className="line-clamp-1 text-center text-xl text-orangeOne md:leading-[35px]"> {titleOne}</div>
                  <div className="line-clamp-1 text-center font-bold text-orangeOne sm:line-clamp-2 sm:text-2xl md:text-3xl md:leading-[35px]">
                    {titleTwo}
                  </div>
                </div>}
            </Box>
            <div className="my-2 flex w-full sm:mt-8">
              <Button href="#subscription" as="a" variant="shadow" color="orange" radius="circle" className="order-1 mx-auto   !hidden w-full max-w-[290px] cursor-pointer items-center sm:hidden md:!w-full">
                خرید اشتراک
              </Button>
            </div>
          </Container>
        </div>}
    </div>;
};
export default SubscriptionPageVideo;